import axios from "axios";
import { tokenUtil } from "@acclaim/udaf-kit";
import { useSelector } from "react-redux";
import { selectAdminInspectors } from "selectors/adminInspectors";

const getInspectorListFromAPI = () => {
  const adminInspectorsList = useSelector(selectAdminInspectors);
  // console.log("getInspectorsListFromAPI", adminInspectorsList);
  // returning items array
  return adminInspectorsList;
};

export const getInspectorList = () => {
  const items = getInspectorListFromAPI();
  return items.map((item) => {
    return { id: item.id, title: item.inspector_name };
  });
};

//cash, check, creditcard, pay_later released_at_no_charge

// SR_50852 Add Invoice Payment Option

export const getPaymentTypeList = () => {
  const items = [
    { id: "cash", title: "Cash" },
    { id: "check", title: "Check" },
    { id: "creditcard", title: "Creditcard" },
    { id: "pay_later", title: "Pay Later" },
    { id: "released_at_no_charge", title: "Released at no charge" },
    { id: "invoice", title: "Invoice" },
  ];
  return items;
};

// Completed, Exempt, Paid, Pending, Unpaid, Refunded

export const getPaymentStatusList = () => {
  const items = [
    { id: "Completed", title: "Completed" },
    { id: "Exempt", title: "Exempt" },
    { id: "Pending", title: "Pending" },
    { id: "Unpaid", title: "Unpaid" },
    { id: "Refunded", title: "Refunded" },
  ];
  return items;
};

// After client creation

export const getAdminInspectionsApiUrl = () => {
  return `${netApiBaseUrl()}/outbound/admininspections?`;
};

export const getAdminInspectionsPaymentLogApiUrl = () => {
  return `${netApiBaseUrl()}/outbound/paymentlog?paymentId=`;
};

export const getAdminInspectionsReconcileApiUrl = () => {
  return `${netApiBaseUrl()}/inbound/adminreconcile`;
};

export const getAdminInspectionsUnreconcileApiUrl = () => {
  return `${netApiBaseUrl()}/inbound/adminunreconcile`;
};

export const getAdminEditPaymentApiUrl = () => {
  return `${netApiBaseUrl()}/inbound/editpayments`;
};

const netApiBaseUrl = () => {
  let definedHost = (window.location.hostname ?? "").toLocaleLowerCase();
  let baseNetAPIURL;

  if (definedHost.includes("localhost")) {
    // Temp for testing
    baseNetAPIURL = "https://localhost:7891/api/inspection";
  } else if (definedHost.includes("staging")) {
    baseNetAPIURL =
      "https://agbrands-inspection-api-staging.brands.utah.gov/api/inspection";
  } else {
    baseNetAPIURL =
      "https://agbrands-inspection-api.brands.utah.gov/api/inspection";
  }

  return baseNetAPIURL;
};

// create axios client with bearer token
export function createNetInspectionApiClient() {
  const api = axios.create({
    timeout: 60000,
    headers: {
      Authorization: `Bearer ${tokenUtil.getToken()}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

  return api;
}
